import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { QUALITY, QUALITY_ADD, QUALITY_DELETE } from "./actionTypes";
import {
	apiError,
	getQuality,
	qualityListSuccessful,
	qualityAddSuccessful,
} from "./actions";

// AUTH related methods
import {
	postAdd,
	getList,
	postEdit,
	postDelete,
} from "../../../helpers/Helper";
import swal from "sweetalert";

function* getQualities() {
	try {
		const response = yield call(getList, "/masters/quality/", {});
		yield put(qualityListSuccessful({ response }));
	} catch (error) {
		yield put(apiError(error));
	}
}
//If user is login then dispatch redux action's are directly from here.
function* AddQuality({ payload: { quality } }) {
	try {
		console.log(quality, "&&&&&&&&&&&&&&&&&");
		if (quality.id === 0) {
			const response = yield call(postAdd, "/masters/quality/", {
				name: quality.name,
			});
			if (response.status === 201) {
				swal("YourQuality Added Successfully.!", {
					icon: "success",
					timer: 1500,
				});
				yield put(getQuality());
			} else {
				swal("Sorry! Unable to add Quality. Please Try Again!", {
					icon: "error",
				});
			}
			yield put(qualityAddSuccessful(null));
		} else {
			const response = yield call(
				postEdit,
				"/masters/quality/" + quality.id,
				{
					code: quality.code,
					name: quality.name,
					modifiedon: new Date(quality.createdon),
				}
			);
			if (response.status === 200) {
				swal("Your Quality Edited Successfully.!", {
					icon: "success",
					timer: 1500,
				});
				yield put(getQuality());
			} else {
				swal("Sorry! Unable to edit Quality. Please Try Again!", {
					icon: "error",
				});
			}
			yield put(qualityAddSuccessful(null));
		}
	} catch (error) {
		swal("Sorry! Permission Denied!", {
			icon: "error",
		});
		//yield put(apiError(error));
	}
}

//If user is login then dispatch redux action's are directly from here.
function* DeleteQuality(qualityId) {
	try {
		const response = yield call(
			postDelete,
			"/masters/quality/" + qualityId.payload.qualityId
		);

		if (response.status === 204) {
			swal(" Your Quality has been deleted!", {
				icon: "success",
				timer: 1500,
			});
			yield put(getQuality());
		} else {
			swal("Sorry! Your Quality has been not deleted!", {
				icon: "error",
			});
		}
	} catch (error) {
		swal("Sorry! Permission Denied!", {
			icon: "error",
		});

		yield put(apiError(error));
	}
}

export function* watchgetQuality() {
	yield takeEvery(QUALITY, getQualities);
}
export function* watchQualityAdd() {
	yield takeEvery(QUALITY_ADD, AddQuality);
}

export function* watchQualityDelete() {
	yield takeEvery(QUALITY_DELETE, DeleteQuality);
}

function* QualitySaga() {
	yield all([
		fork(watchgetQuality),
		fork(watchQualityAdd),
		fork(watchQualityDelete),
	]);
}

export default QualitySaga;
